import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { Sparkles, RotateCw } from "lucide-react";

export default function Quiz() {
  const [quiz, setQuiz] = useState(null);
  const [answers, setAnswers] = useState({});
  const [result, setResult] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => { api.get("/quiz/copil-alienat").then(r => setQuiz(r.data)).catch(() => {}); }, []);

  const submit = async () => {
    if (!quiz) return;
    const arr = quiz.questions.map((_, i) => answers[i] ?? 0);
    setSubmitting(true);
    try {
      const { data } = await api.post("/quiz/submit", { quiz_type: "copil-alienat", answers: arr });
      setResult(data);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } finally {
      setSubmitting(false);
    }
  };

  const reset = () => { setAnswers({}); setResult(null); };

  if (!quiz) return <div className="max-w-3xl mx-auto px-4 py-32 text-[#A0AABF]">Se încarcă testul...</div>;

  if (result) {
    const colorClass = result.level === "low" ? "text-[#3BA76D]" : result.level === "medium" ? "text-[#D4A63D]" : "text-[#C83A3A]";
    return (
      <div data-testid="quiz-result" className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 text-center">
        <Sparkles className="w-12 h-12 text-[#D4A63D] mx-auto mb-6" />
        <p className="text-xs tracking-[0.3em] text-[#D4A63D] uppercase mb-4">Rezultat test</p>
        <h1 className={`font-display text-5xl md:text-7xl ${colorClass}`}>{result.result.label}</h1>
        <p className="mt-4 text-[#A0AABF]">Scor: {result.score}/{result.max_score} ({result.percentage}%)</p>
        <p className="mt-8 text-[#F8F8F4]/90 text-lg leading-relaxed max-w-xl mx-auto">{result.result.advice}</p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/programare" className="btn-gold rounded-sm px-6 py-3 text-sm uppercase tracking-widest">Vorbește cu Gabriel</Link>
          <Link to="/ajutor" className="btn-ghost-light rounded-sm px-6 py-3 text-sm uppercase tracking-widest">Ghid de acțiune</Link>
          <button onClick={reset} className="text-[#A0AABF] hover:text-[#D4A63D] px-4 py-3 text-sm inline-flex items-center gap-2"><RotateCw className="w-4 h-4" /> Reia testul</button>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="page-quiz" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
      <header className="mb-10">
        <p className="text-xs tracking-[0.3em] text-[#D4A63D] uppercase mb-4">Test rapid</p>
        <h1 className="font-display text-4xl md:text-5xl text-[#F8F8F4]">{quiz.title}</h1>
        <p className="mt-4 text-[#A0AABF] text-lg">{quiz.description}</p>
      </header>

      <div className="space-y-5">
        {quiz.questions.map((q, i) => (
          <div key={i} className="cinematic-card rounded-lg p-5">
            <p className="text-[#F8F8F4] mb-4 text-base md:text-lg">{i + 1}. {q}</p>
            <div className="flex gap-2 flex-wrap">
              {[
                { v: 0, l: "Niciodată" },
                { v: 1, l: "Uneori" },
                { v: 2, l: "Frecvent" },
              ].map(o => (
                <button
                  key={o.v}
                  data-testid={`q${i}-a${o.v}`}
                  onClick={() => setAnswers(a => ({ ...a, [i]: o.v }))}
                  className={`px-4 py-2 rounded-sm text-sm transition-all border ${
                    answers[i] === o.v ? "bg-[#D4A63D] text-[#0A1020] border-[#D4A63D]" : "border-white/10 text-[#A0AABF] hover:border-[#D4A63D]/40"
                  }`}
                >
                  {o.l}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>

      <button
        data-testid="quiz-submit"
        onClick={submit}
        disabled={submitting || Object.keys(answers).length < quiz.questions.length}
        className="btn-gold rounded-sm px-7 py-4 mt-8 w-full text-sm uppercase tracking-widest font-medium disabled:opacity-40"
      >
        {submitting ? "Se calculează..." : "Vezi rezultatul"}
      </button>
    </div>
  );
}
